export const canAccessPeopleFinderProject = ({ findemUserId, projectUserIds = [] }) =>
  Boolean(findemUserId) && Array.isArray(projectUserIds) && projectUserIds.includes(findemUserId);

export const buildPeopleFinderProjectPath = ({ projectId, projectOwnerId, findemUserId }) => {
  if (!projectId || !projectOwnerId || !findemUserId) return null;

  const params = new URLSearchParams({
    joid: projectOwnerId,
    redirect_joid: findemUserId,
    tab: 'search',
    channel: 'external',
  });

  return `/searches/${encodeURIComponent(projectId)}?${params.toString()}`;
};

export const buildPeopleFinderProjectRoute = ({ networkSlug, ...project }) => {
  const projectPath = buildPeopleFinderProjectPath(project);
  if (!networkSlug || !projectPath) return null;

  return `/networks/${networkSlug}/projects?url=${encodeURIComponent(projectPath)}`;
};
